var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isFreePlan||_vm.isTrialPlan)?_c('div',[_c('v-btn',{class:_vm.isExpiredAccount?'orange':'white',attrs:{"outline":"","small":"","title":"Click to view plan options"}},[_c('span',{class:_vm.isExpiredAccount?'orange--text':'white--text'},[_vm._v(_vm._s(_vm.accountName))])])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }